var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectorRef, OnInit } from '@angular/core';
import { PageNames } from '../../../shared/page-names.enum';
import { EmitterConstants } from '../../../shared/emitter-constants';
import { Emitter } from '../../../shared/utils/emitter/emitter';
import { OrderFailedComponent } from '../../ordering-modals/order-failed/order-failed.component';
import { NavigationService } from '../../../services/navigation/navigation.service';
import { OmapiIdConstants } from '../../../shared/omapi-id-constants';
var TrialActivationPendingModalComponent = /** @class */ (function (_super) {
    __extends(TrialActivationPendingModalComponent, _super);
    function TrialActivationPendingModalComponent(navigationService, changeDetector) {
        var _this = _super.call(this, navigationService, changeDetector) || this;
        _this.navigationService = navigationService;
        _this.changeDetector = changeDetector;
        _this.componentName = PageNames.TRIAL_ACTIVATION_PENDING;
        return _this;
    }
    TrialActivationPendingModalComponent.prototype.onEmitClosePendingFailed = function () {
        Emitter.of(EmitterConstants.BACK_PRESSED).emit(this.componentName);
    };
    TrialActivationPendingModalComponent.prototype.onBack = function () {
        Emitter.of(EmitterConstants.BACK_PRESSED).emit(this.componentName);
    };
    TrialActivationPendingModalComponent.prototype.setLabel = function (error) {
        this.label = 'eos-tv-shop-ii.text.order-message';
    };
    TrialActivationPendingModalComponent.prototype.trialName = function () {
        return OmapiIdConstants.PRODUCT_NAME_MAP.get(this.trialOmapiId);
    };
    return TrialActivationPendingModalComponent;
}(OrderFailedComponent));
export { TrialActivationPendingModalComponent };
